export const OFFER_COLUMNS = [
  { id: 'event', label: 'Offer', alwaysVisible: true, defaultVisible: true },
  { id: 'offer_created', label: 'Created Date', defaultVisible: true },
  { id: 'owner', label: 'Created By', defaultVisible: true },
  { id: 'buyer', label: 'Buyer', defaultVisible: false },
  { id: 'status', label: 'Status', defaultVisible: true },
  { id: 'type', label: 'Type', defaultVisible: false },
  { id: 'event_date', label: 'Event Date', defaultVisible: false },
  { id: 'event_status', label: 'Event Status', defaultVisible: false },
  { id: 'holds', label: 'Holds', defaultVisible: false },
  { id: 'venue_name', label: 'Venue Name', defaultVisible: false },
  { id: 'genre', label: 'Genre', defaultVisible: false },
];

export const getDefaultVisibleColumns = () => OFFER_COLUMNS.filter(c => c.defaultVisible);
export const getDefaultHiddenColumns = () => OFFER_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
